<!-- 须知配置弹窗组件 - PC 端 -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="须知配置"
    width="800px"
    :close-on-click-modal="false"
    custom-class="notice-config-dialog"
    @close="handleClose"
  >
    <el-form :model="noticeConfig" label-width="100px" label-position="right">
      <!-- 须知内容（独占一行） -->
      <el-form-item label="须知内容">
        <rich-text-editor
          v-model="noticeConfig.noticeContent"
          placeholder="请填写须知内容"
          :maxlength="300"
          @count-change="onContentCountChange"
        />
      </el-form-item>

      <el-divider />

      <!-- 双列布局区域 -->
      <div class="form-row">
        <!-- 展示时长 -->
        <el-form-item label="展示时长" class="half-item">
          <el-select
            v-model="noticeConfig.noticeDuration"
            placeholder="请选择展示时长"
            style="width: 100%"
          >
            <el-option label="不限制" :value="0" />
            <el-option label="停留阅读3秒" :value="3" />
            <el-option label="停留阅读5秒" :value="5" />
            <el-option label="停留阅读10秒" :value="10" />
          </el-select>
        </el-form-item>

        <!-- 展示时机 -->
        <el-form-item label="展示时机" class="half-item">
          <el-select
            v-model="noticeConfig.noticeTiming"
            placeholder="请选择展示时机"
            style="width: 100%"
          >
            <el-option label="进入活动详情立即展示" :value="1" />
            <el-option label="提交前展示" :value="2" />
          </el-select>
        </el-form-item>

        <!-- 须知确认方式 -->
        <el-form-item label="确认方式" class="half-item">
          <el-select
            v-model="noticeConfig.noticeConfirmType"
            placeholder="请选择确认方式"
            style="width: 100%"
          >
            <el-option label="点击按钮同意" :value="1" />
            <el-option label="签字同意" :value="2" />
          </el-select>
        </el-form-item>
      </div>

      <el-divider />

      <!-- 标题 + 按钮文案 -->
      <div class="form-row">
        <!-- 须知弹窗标题 -->
        <el-form-item label="弹窗标题" class="half-item">
          <el-input
            v-model="noticeConfig.noticeTitle"
            placeholder="必读须知"
            maxlength="10"
          />
        </el-form-item>

        <!-- 已读按钮文案 -->
        <el-form-item label="按钮文案" class="half-item">
          <el-input
            v-model="noticeConfig.noticeButtonText"
            placeholder="已读并确认以上内容"
            maxlength="9"
          />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
          >保 存</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script>
import RichTextEditor from "./RichTextEditor.vue";
import { normalizeHtml } from "./richTextUtils.js";

export default {
  name: "NoticeConfigDialog",
  components: {
    RichTextEditor,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => null,
    },
  },
  emits: ["update:visible", "save"],
  data() {
    return {
      noticeConfig: this.getDefaultConfig(),
      contentTextCount: 0,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initConfig();
      }
    },
  },
  methods: {
    getDefaultConfig() {
      return {
        noticeContent: "",
        noticeDuration: 0,
        noticeTiming: 1,
        noticeConfirmType: 1,
        noticeTitle: "必读须知",
        noticeButtonText: "已读并确认以上内容",
        noticeEnabled: 1,
      };
    },
    initConfig() {
      const defaults = this.getDefaultConfig();
      // 重开弹层时重置字数，避免残留上一次的计数
      this.contentTextCount = 0;
      if (this.config && Object.keys(this.config).length > 0) {
        const cleaned = {};
        for (const key of Object.keys(this.config)) {
          const val = this.config[key];
          if (val !== "" && val !== null && val !== undefined) {
            cleaned[key] = val;
          }
        }
        this.noticeConfig = { ...defaults, ...cleaned };
      } else {
        this.noticeConfig = { ...defaults };
      }
      // 历史数据兜底：旧版 4 秒等已下线取值归一为不限制，与小程序端语义一致
      if (![0, 3, 5, 10].includes(this.noticeConfig.noticeDuration)) {
        this.noticeConfig.noticeDuration = 0;
      }
    },

    onContentCountChange(count) {
      this.contentTextCount = count;
    },

    handleSave() {
      // 校验规则与小程序端 noticeSettings.vue 保持一致
      const noticeContent = normalizeHtml(this.noticeConfig.noticeContent);
      if (!noticeContent) {
        this.$message.warning("请输入须知内容");
        return;
      }
      if (this.contentTextCount > 300) {
        this.$message.warning("须知内容不能超过300字");
        return;
      }

      const config = { ...this.noticeConfig, noticeContent };
      if (!config.noticeTitle) {
        config.noticeTitle = "必读须知";
      }
      if (!config.noticeButtonText) {
        config.noticeButtonText = "已读并确认以上内容";
      }

      this.$emit("save", config);
      this.handleClose();
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-config-dialog {
  :deep(.el-dialog__body) {
    padding: 20px 28px;
  }
}

// 双列布局
.form-row {
  display: flex;
  gap: 0;

  .half-item {
    width: 50%;
  }
}

.el-divider {
  margin: 12px 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
